import script from "./WebAssistantPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebAssistantPreview.vue?vue&type=script&lang=ts&setup=true"

import "./WebAssistantPreview.vue?vue&type=style&index=0&id=0fa99352&lang=scss"
import "./WebAssistantPreview.vue?vue&type=style&index=1&id=0fa99352&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa99352"]])

export default __exports__